var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.isDisplayed ? "displayed" : "",
      attrs: { id: "MapModal" },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.preventBubbling()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal_closebt",
          on: {
            click: function($event) {
              return _vm.closeModal()
            }
          }
        },
        [_vm._v("Close")]
      ),
      _c("div", { staticClass: "modal_head" }, [
        _c("div", { staticClass: "head_title" }, [
          _vm._v("\n            " + _vm._s(_vm.countryName) + "\n        ")
        ]),
        _vm.hasData
          ? _c("div", { staticClass: "head_taxhaven" }, [
              _vm._v("\n            " + _vm._s(_vm.taxHavenText) + "\n        ")
            ])
          : _vm._e(),
        _vm.hasData
          ? _c("div", { staticClass: "head_value" }, [
              _c("div", {
                staticClass: "value_chip",
                style: { backgroundColor: _vm.countryColor }
              }),
              _c("div", { staticClass: "value_text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.countryValue) +
                    "\n            "
                )
              ])
            ])
          : _vm._e(),
        _vm.hasData
          ? _c("div", { staticClass: "head_text" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.countryHeadText) + "\n        "
              )
            ])
          : _c("div", { staticClass: "head_text" }, [
              _vm._v("\n            No data\n        ")
            ])
      ]),
      _vm.hasData
        ? _c(
            "div",
            {
              staticClass: "modal_table",
              attrs: { "data-dataset": _vm.datasetID }
            },
            [
              _vm.datasetID == "global-profit" && !_vm.isTaxHaven
                ? _c(
                    "table",
                    { staticClass: "table_data" },
                    [
                      _vm._m(0),
                      _vm._l(_vm.globalProfitDataTable, function(
                        rowObj,
                        rowInc
                      ) {
                        return _c(
                          "tr",
                          {
                            staticClass: "row",
                            attrs: {
                              "data-type": rowObj.type,
                              "data-inc": rowInc,
                              "data-oddeven": rowObj.oddEven
                            }
                          },
                          [
                            _c("td", { staticClass: "bordered label" }, [
                              _vm._v(_vm._s(rowObj.label))
                            ]),
                            _c("td", { staticClass: "bordered" }, [
                              _vm._v(_vm._s(rowObj.data[0]))
                            ]),
                            _c("td", { staticClass: "bordered" }, [
                              _vm._v(_vm._s(rowObj.data[1]))
                            ]),
                            _c("td", [_vm._v(_vm._s(rowObj.data[2]))])
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.datasetID == "global-profit" && _vm.isTaxHaven
                ? _c(
                    "table",
                    { staticClass: "table_data twocols" },
                    _vm._l(_vm.globalProfitDataTableTaxHaven, function(
                      rowObj,
                      rowInc
                    ) {
                      return _c("tr", { staticClass: "row" }, [
                        _c("td", { staticClass: "bordered" }, [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(rowObj.label) }
                          })
                        ]),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(rowObj.value) +
                              "\n                "
                          )
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm.datasetID == "offshore-financial" && !_vm.isTaxHaven
                ? _c(
                    "table",
                    { staticClass: "table_data twocols threecols" },
                    [
                      _vm._m(1),
                      _vm._l(_vm.offshoreFinancialDataTable, function(
                        rowObj,
                        rowInc
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c("td", { staticClass: "bordered" }, [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(rowObj.label) }
                            })
                          ]),
                          _c("td", { staticClass: "bordered" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(rowObj.value) +
                                "\n                "
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(rowObj.valuePct) +
                                "\n                "
                            )
                          ])
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.datasetID == "offshore-financial" && _vm.isTaxHaven
                ? _c(
                    "table",
                    { staticClass: "table_data twocols threecols" },
                    [
                      _vm._m(2),
                      _vm._l(_vm.offshoreFinancialDataTableTaxHaven, function(
                        rowObj,
                        rowInc
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c("td", { staticClass: "bordered" }, [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(rowObj.label) }
                            })
                          ]),
                          _c("td", { staticClass: "bordered" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(rowObj.value) +
                                "\n                "
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(rowObj.valuePct) +
                                "\n                "
                            )
                          ])
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.datasetID == "offshore-real-estate"
                ? _c(
                    "table",
                    { staticClass: "table_data" },
                    [
                      _vm._m(3),
                      _vm._l(_vm.offshoreRealEstateDataTable, function(
                        rowObj,
                        rowInc
                      ) {
                        return _c(
                          "tr",
                          {
                            staticClass: "row",
                            attrs: {
                              "data-type": rowObj.type,
                              "data-inc": rowInc,
                              "data-oddeven": rowObj.oddEven
                            }
                          },
                          [
                            _c("td", { staticClass: "bordered label" }, [
                              _vm._v(_vm._s(rowObj.label))
                            ]),
                            _c("td", { staticClass: "bordered" }, [
                              _vm._v(_vm._s(rowObj.data[0]))
                            ]),
                            _c("td", { staticClass: "bordered" }, [
                              _vm._v(_vm._s(rowObj.data[1]))
                            ]),
                            _c("td", [_vm._v(_vm._s(rowObj.data[2]))])
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.datasetID == "effective-tax"
                ? _c("div", { staticClass: "table_effective_tax" }, [
                    _c("div", { staticClass: "table_encart" }, [
                      _vm._v(
                        "\n                Effective tax rates\n            "
                      )
                    ]),
                    _c(
                      "table",
                      { staticClass: "table_data fivecols" },
                      [
                        _c("tr", { staticClass: "head" }, [
                          _c("th", { staticClass: "cell bordered" }, [
                            _vm._v("Variable")
                          ]),
                          _c("th", { staticClass: "cell bordered" }, [
                            _vm._v("Country Value"),
                            _c("br"),
                            _vm._v("(Year " + _vm._s(_vm.selectedYear) + ")")
                          ]),
                          _vm._m(4),
                          _c("th", { staticClass: "cell bordered" }, [
                            _vm._v("Region average"),
                            _c("br"),
                            _vm._v("(Year " + _vm._s(_vm.selectedYear) + ")")
                          ]),
                          _c("th", { staticClass: "cell" }, [
                            _vm._v("Income average"),
                            _c("br"),
                            _vm._v("(Year " + _vm._s(_vm.selectedYear) + ")")
                          ])
                        ]),
                        _vm._l(_vm.effectiveTaxDataTable, function(
                          rowObj,
                          rowInc
                        ) {
                          return _c(
                            "tr",
                            {
                              staticClass: "row",
                              attrs: {
                                "data-type": rowObj.type,
                                "data-inc": rowInc,
                                "data-oddeven": rowObj.oddEven
                              }
                            },
                            [
                              _c("td", { staticClass: "bordered label" }, [
                                _vm._v(_vm._s(rowObj.label))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[0]))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[1]))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[2]))
                              ]),
                              _c("td", [_vm._v(_vm._s(rowObj.data[3]))])
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _c("div", { staticClass: "table_encart encart2" }, [
                      _vm._v(
                        "\n                decomposition tax revenue in year " +
                          _vm._s(_vm.selectedYear) +
                          " (% of total)\n            "
                      )
                    ]),
                    _c(
                      "table",
                      { staticClass: "table_data sevencols" },
                      [
                        _vm._m(5),
                        _vm._l(_vm.effectiveTaxDataTable2, function(
                          rowObj,
                          rowInc
                        ) {
                          return _c(
                            "tr",
                            {
                              staticClass: "row",
                              attrs: {
                                "data-type": rowObj.type,
                                "data-inc": rowInc,
                                "data-oddeven": rowObj.oddEven
                              }
                            },
                            [
                              _c("td", { staticClass: "bordered label" }, [
                                _vm._v(_vm._s(rowObj.label))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[0]))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[1]))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[2]))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[3]))
                              ]),
                              _c("td", { staticClass: "bordered" }, [
                                _vm._v(_vm._s(rowObj.data[4]))
                              ]),
                              _c("td", [_vm._v(_vm._s(rowObj.data[5]))])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "head" }, [
      _c("th", { staticClass: "cell bordered" }, [_vm._v(" ")]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Profits lost ($, Bln)")
      ]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Tax revenue lost ($, Bln)")
      ]),
      _c("th", { staticClass: "cell" }, [
        _vm._v("Tax revenue lost"),
        _c("br"),
        _vm._v("(% of corporate tax revenue)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "head" }, [
      _c("th", { staticClass: "cell bordered" }, [_vm._v(" ")]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Offshore Wealth"),
        _c("br"),
        _vm._v("($, Billions)")
      ]),
      _c("th", { staticClass: "cell" }, [
        _vm._v("Offshore Wealth"),
        _c("br"),
        _vm._v("(% of GDP)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "head" }, [
      _c("th", { staticClass: "cell bordered" }, [_vm._v(" ")]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Offshore Wealth"),
        _c("br"),
        _vm._v("($, Billions)")
      ]),
      _c("th", { staticClass: "cell" }, [
        _vm._v("Offshore wealth held in tax haven"),
        _c("br"),
        _vm._v("as a share of region's GDP (% of GDP)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "head" }, [
      _c("th", { staticClass: "cell bordered" }, [_vm._v(" ")]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Offshore real estate owned as a share of country’s GDP (in %)")
      ]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Total offshore real estate owned"),
        _c("br"),
        _vm._v("(in  B$)")
      ]),
      _c("th", { staticClass: "cell" }, [
        _vm._v("Share of total offshore real estate in city owned"),
        _c("br"),
        _vm._v("(in %)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "cell bordered" }, [
      _vm._v("Country Mean"),
      _c("br"),
      _vm._v("(full period)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "head" }, [
      _c("th", { staticClass: "cell bordered" }, [_vm._v("Tax category")]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Personal Income Tax")
      ]),
      _c("th", { staticClass: "cell bordered" }, [
        _vm._v("Corporate Income Tax")
      ]),
      _c("th", { staticClass: "cell bordered" }, [_vm._v("Payroll Tax")]),
      _c("th", { staticClass: "cell bordered" }, [_vm._v("Property Tax")]),
      _c("th", { staticClass: "cell bordered" }, [_vm._v("Indirect Tax")]),
      _c("th", { staticClass: "cell" }, [_vm._v("Other Taxes")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-340fe68c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340fe68c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/MapModal.vue
// module id = zB8s
// module chunks = 0 1